import styled, { css } from 'styled-components';

import { setTypography } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';
import { colors } from 'utils/styles/theme';

export const MultiSelectListWrapper = styled.div`
  position: relative;
  ${({ theme: { locale } }) => setTypography('smallBody', locale)}
  cursor: pointer;
`;

export const SelectButton = styled.div`
  border: 1px solid ${colors.mercury};
  padding: 14px 0 14px 20px;
`;

export const SelectionList = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 100%;
  max-height: 280px;
  width: 100%;
  border-top: none;
  overflow-y: auto;
  opacity: 0;
  pointer-events: none;
  transition: opacity 150ms;
  border: 1px solid ${colors.mercury};
  background-color: ${colors.white};
  z-index: 2;

  ${({ isOpen }) =>
    isOpen &&
    css`
      opacity: 1;
      pointer-events: all;
    `}

  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: ${colors.mercury};
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: ${colors.lighterMineShaft};
  }

  /* Handle on hover */
  /* &::-webkit-scrollbar-thumb:hover {
    background: #555;
  } */
`;

export const List = styled.div`
  padding: 20px 0 10px 20px;
`;

export const Item = styled.div<{ isEnabled: boolean }>`
  padding-bottom: 13px;
  display: flex;
  align-items: center;

  ${({ isEnabled }) =>
    !isEnabled &&
    css`
      opacity: 0.5;
      cursor: default;
    `}
`;

export const Checkbox = styled.div<{ isSelected: boolean }>`
  border: 1px solid ${colors.black};
  width: 16px;
  height: 16px;

  display: flex;
  align-items: center;
  justify-content: center;

  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: ${colors.black};

      /* svg {
        width: 100%;
        height: 100%;
      } */
    `}
`;

export const Name = styled.div`
  margin-left: 15px;
`;

export const BackgroundOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;

export const Arrow = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: 50%;
  right: 20px;
  transform: translateY(-50%);

  ${({ isOpen }) =>
    isOpen &&
    css`
      transform: translateY(-50%) rotate(180deg);
    `}

  ${mediaDesktop(
    css`
      right: 20px;
    `
  )}
`;
